import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import AvdImage from '../../../assets/images/avd.jpg';
import AVDComparison from '../../ui/avd-comparison';
import AVDCaseComparison from '../../ui/avd-case-comparison';
import './IntroSectionInfraCloud.css';

const IntroSectionInfraCloud3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Secure Teleworking
  const teleworkingStats = [
    {
      value: '500+',
      label: 'Entreprises en télétravail sécurisé',
      translationKey: 'teleworking.stats.companies',
      labelTranslationKey: 'teleworking.stats.companiesLabel'
    },
    {
      value: '99.8%',
      label: 'Disponibilité AVD garantie',
      translationKey: 'teleworking.stats.availability',
      labelTranslationKey: 'teleworking.stats.availabilityLabel'
    },
    {
      value: '< 1h',
      label: 'Temps de connexion',
      translationKey: 'teleworking.stats.connection',
      labelTranslationKey: 'teleworking.stats.connectionLabel'
    },
    {
      value: '100%',
      label: 'Sécurité des données',
      translationKey: 'teleworking.stats.security',
      labelTranslationKey: 'teleworking.stats.securityLabel'
    }
  ];

  const teleworkingChartData = [
    { name: "Jan", value: 75 },
    { name: "Feb", value: 80 },
    { name: "Mar", value: 85 },
    { name: "Apr", value: 90 },
    { name: "May", value: 95 },
    { name: "Jun", value: 98 },
    { name: "Jul", value: 100 },
  ];

  return (
    <div className="intro-section-home intro-section-infra-cloud">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('infraCloud.introSection.commitment', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        titleTranslationKey="teleworking.stats.title"
        subtitleTranslationKey="teleworking.stats.subtitle"
        stats={teleworkingStats}
        imageSrc={AvdImage}
        imageAlt="Azure Virtual Desktop - Télétravail sécurisé"
        chartData={teleworkingChartData}
        showChart={true}
      />
      <div className="tw-mt-10">
        <AVDComparison />
      </div>

      <div className="tw-mt-8">
        <AVDCaseComparison />
      </div>
    </div>
  );
};

export default IntroSectionInfraCloud3;
